import _ from 'lodash';
import { createSelector } from 'reselect';

import Enums from '../../common/enums';

const _scopedState = (state) => state.entities.account;

const activeAccount = (state) => _scopedState(state).active;

const _relativeAccountsById = (state) => _scopedState(state).relativeAccounts.byId;

const relativeAccounts = createSelector([_relativeAccountsById], (accounts) => _.values(accounts));

const relativeAccountsOrdered = createSelector(
  [relativeAccounts, (state, orderBy) => ({ orderBy })],
  (accounts, { orderBy }) =>
    _.orderBy(accounts, [(account) => account[orderBy].toLowerCase()], Enums.sortDirections.ASCENDING)
);

const accountApiData = (state) => activeAccount(state).apiData || {};

export default {
  activeAccount,

  relativeAccounts,
  relativeAccountsOrdered,
  accountApiData,
};
